import { alpha, Box, Typography } from '@mui/material';
import useBundleTranslation from 'i18n';
import { REPORT_ACTIVE_STROKE } from './nodeTypeColors';

interface LegendStripProps {
    typeColors: Map<string, string>;
    reportLensActive?: boolean;
}

// DOM twin of the in-SVG Legend for embedded mounts (Figma 935:9906 draws the legend as the focus
// card's footer row, outside the drawing).
export default function LegendStrip({ typeColors, reportLensActive = false }: LegendStripProps) {
    const { t } = useBundleTranslation('components/common/knowledge-graph/panel');
    const entries = [...typeColors.entries()];
    if (!entries.length) return null;

    return (
        <Box
            data-test="kg_graph_legend_strip"
            sx={(theme) => ({
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                px: 1.5,
                py: 1,
                borderTop: `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
                flexShrink: 0,
            })}
        >
            {entries.map(([type, color]) => (
                <Box key={type} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
                    <Typography sx={{ fontSize: '12px', lineHeight: '18px' }}>
                        {t(`type_${type.toLowerCase()}`, type)}
                    </Typography>
                </Box>
            ))}
            {reportLensActive && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} data-test="kg_graph_legend_in_report">
                    <Box
                        sx={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            border: `2px solid ${REPORT_ACTIVE_STROKE}`,
                            boxSizing: 'border-box',
                            flexShrink: 0,
                        }}
                    />
                    <Typography sx={{ fontSize: '12px', lineHeight: '18px' }}>
                        {t('legend_in_report', 'In this report')}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
